var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedCheckbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Checkbox"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checkbox"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 7,
    fill: "var(--primary-color-highlight__dark)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 7,
    stroke: "var(--primary-color-highlight__dark)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.2498 18.7295C10.1575 18.7263 10.0668 18.7044 9.98327 18.665C9.89973 18.6256 9.82512 18.5696 9.76401 18.5003L5.18067 13.917C5.09329 13.8603 5.01991 13.7845 4.96609 13.6954C4.91228 13.6062 4.87942 13.506 4.87 13.4022C4.86059 13.2985 4.87486 13.194 4.91174 13.0966C4.94863 12.9992 5.00715 12.9115 5.08291 12.84C5.15867 12.7685 5.24967 12.7152 5.34905 12.6841C5.44843 12.6529 5.55359 12.6447 5.65659 12.6602C5.75958 12.6756 5.85773 12.7143 5.94361 12.7732C6.02949 12.8321 6.10086 12.9097 6.15234 13.0003L10.2498 17.0703L19.8473 7.50029C19.9765 7.41651 20.1301 7.37854 20.2835 7.39246C20.4369 7.40639 20.5811 7.47139 20.6931 7.57707C20.8051 7.68274 20.8784 7.82296 20.9013 7.97525C20.9241 8.12754 20.8951 8.28309 20.819 8.41695L10.7357 18.5003C10.6746 18.5696 10.5999 18.6256 10.5164 18.665C10.4329 18.7044 10.3422 18.7263 10.2498 18.7295Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCheckbox);
export default __webpack_public_path__ + "static/media/checked_checkbox.044a9b5c5f9f1458a60b947363f9cae1.svg";
export { ForwardRef as ReactComponent };